export default __webpack_public_path__ + "static/media/favicon.e9603794.ico";